import { useState } from "react";
import { useTheme } from "../../context/ThemeContext";
import { 
  Code, LineChart, Paintbrush, Shield, Star, History, 
  ChevronDown, ChevronUp, FileText, DollarSign, Settings, 
  Image, File, Lock, Percent, Mic, Calendar, Link, 
  Clipboard, Type, Palette, Layers, Keyboard, FileImage,
  FileArchive, FileCode, FileInput, FileOutput, FileDigit,
  Binary, Hash, Bold, Italic, Volume2, Calculator, 
  Table2, FileSpreadsheet, FilePieChart, FileKey2, FileLock,
  FileSearch, FilePlus2, FileMinus2, FileX2, FileCheck2,
  FileClock, FileUp, FileDown, FileStack, FileBarChart2,
  FileHeart, FileJson, FileTerminal, FileVideo, FileAudio
} from "lucide-react";

const Sidebar = () => {
  useTheme();
  const [activeCategory, setActiveCategory] = useState(null);
  const [expandedCategories, setExpandedCategories] = useState({});

  // All tools with their categories - paths updated to match ToolLayout
  const tools = [
    // Designing Tools
    { id: 1, name: "Fancy Text Generator", path: "fancy-text-generator", category: "Designing", icon: <Type size={16} /> },
    { id: 2, name: "Social Media Mockup", path: "social-media-mockup-generator", category: "Designing", icon: <FileImage size={16} /> },
    { id: 9, name: "Image Compressor", path: "compress-image", category: "Designing", icon: <FileArchive size={16} /> },
    { id: 10, name: "Color Picker", path: "color-picker", category: "Designing", icon: <Palette size={16} /> },
    { id: 51, name: "RGB to Hex", path: "rgb-to-hex", category: "Designing", icon: <Palette size={16} /> },
    { id: 59, name: "Text to Handwriting", path: "text-to-handwriting", category: "Designing", icon: <Type size={16} /> },
    { id: 60, name: "Case Converter", path: "case-converter", category: "Designing", icon: <Type size={16} /> },
    { id: 61, name: "Letter Counter", path: "letter-counter", category: "Designing", icon: <Type size={16} /> },
    { id: 62, name: "Lorem Ipsum Generator", path: "lorem-ipsum-generator", category: "Designing", icon: <Type size={16} /> },
    { id: 63, name: "Bionic Reading Converter", path: "bionic-reading-converter", category: "Designing", icon: <Type size={16} /> },
    { id: 64, name: "Whitespace Remover", path: "whitespace-remover", category: "Designing", icon: <Type size={16} /> },
    { id: 65, name: "Font Pair Finder", path: "font-pair-finder", category: "Designing", icon: <Type size={16} /> },
    
    // Development Tools
    { id: 3, name: "Policies Terms", path: "policies-terms", category: "Development", icon: <FileText size={16} /> },
    { id: 4, name: "Loan Amortization", path: "loan-amortization-calculator", category: "Development", icon: <Table2 size={16} /> },
    { id: 6, name: "Calendar Share", path: "calendar-share", category: "Development", icon: <Calendar size={16} /> },
    { id: 7, name: "Multi URL Opener", path: "multi-url-opener", category: "Development", icon: <Link size={16} /> },
    { id: 12, name: "Mortgage Calculator", path: "mortage-calculator", category: "Development", icon: <Calculator size={16} /> },
    { id: 13, name: "Loan Calculator", path: "loan-calculator", category: "Development", icon: <Calculator size={16} /> },
    { id: 15, name: "Num to Words", path: "num-to-words", category: "Development", icon: <FileDigit size={16} /> },
    { id: 16, name: "Percentage Calculator", path: "percentage-calculator", category: "Development", icon: <Percent size={16} /> },
    { id: 19, name: "Remove Duplicates", path: "remove-duplicate", category: "Development", icon: <FileMinus2 size={16} /> },
    { id: 56, name: "Word Count", path: "word-count", category: "Development", icon: <FileDigit size={16} /> },
    { id: 66, name: "Gitignore Generator", path: "gitignore-generator", category: "Development", icon: <FileDigit size={16} /> },
    { id: 67, name: "Sorting Visualizer", path: "sorting-visualizer", category: "Development", icon: <FileDigit size={16} /> },
    
    // Marketing Tools
    { id: 8, name: "Invoice Generator", path: "invoice-generator", category: "Marketing", icon: <FileText size={16} /> },
    { id: 14, name: "Google Ads Calculator", path: "google-ads-calculator", category: "Marketing", icon: <LineChart size={16} /> },
    { id: 17, name: "QR Code Generator", path: "qr-code-generator", category: "Marketing", icon: <FileCode size={16} /> },
    
    // Productivity Tools
    { id: 5, name: "Voice Recorder", path: "voice-recorder-online", category: "Productivity", icon: <Mic size={16} /> },
    { id: 21, name: "Text to Speech", path: "text-to-speach", category: "Productivity", icon: <Volume2 size={16} /> },
    
    // Security Tools
    { id: 11, name: "Email Validator", path: "email-validator", category: "Security", icon: <FileKey2 size={16} /> },
    { id: 18, name: "Password Generator", path: "random-password-generator", category: "Security", icon: <Lock size={16} /> },
    { id: 47, name: "MD5 Hash", path: "md5-hash", category: "Security", icon: <Hash size={16} /> },
    { id: 53, name: "SHA1 Hash", path: "sha1-hash", category: "Security", icon: <Hash size={16} /> },
    { id: 54, name: "SHA256 Hash", path: "sha256-hash", category: "Security", icon: <Hash size={16} /> },
    { id: 55, name: "SHA512 Hash", path: "sha512-hash", category: "Security", icon: <Hash size={16} /> },
    { id: 57, name: "Base64 Decode", path: "base-64-decode", category: "Security", icon: <FileInput size={16} /> },
    { id: 58, name: "Base64 Encode", path: "base-64-encode", category: "Security", icon: <FileOutput size={16} /> },
    
    // Document Converters
    { id: 20, name: "Split PDF", path: "split-pdf", category: "Document", icon: <FileMinus2 size={16} /> },
    { id: 22, name: "JPG to PNG", path: "jpg-to-png", category: "Document", icon: <FileImage size={16} /> },
    { id: 23, name: "PNG to JPG", path: "png-to-jpg", category: "Document", icon: <FileImage size={16} /> },
    { id: 24, name: "HEIC to JPG", path: "heic-to-jpg", category: "Document", icon: <FileImage size={16} /> },
    { id: 25, name: "WebP to JPG", path: "webp-to-jpg-converter", category: "Document", icon: <FileImage size={16} /> },
    { id: 26, name: "Word to JPG", path: "word-to-jpg-converter", category: "Document", icon: <FileImage size={16} /> },
    { id: 27, name: "JPEG to Word", path: "jpeg-to-word-converter", category: "Document", icon: <FileText size={16} /> },
    { id: 28, name: "PDF to Word", path: "pdf-to-word-converter", category: "Document", icon: <FileText size={16} /> },
    { id: 29, name: "PPT to PDF", path: "ppt-to-pdf-converter", category: "Document", icon: <FilePieChart size={16} /> },
    { id: 30, name: "Excel to PDF", path: "excel-to-pdf-converter", category: "Document", icon: <FileSpreadsheet size={16} /> },
    { id: 31, name: "PDF to JPG", path: "pdf-to-jpg-converter", category: "Document", icon: <FileImage size={16} /> },
    { id: 32, name: "JPG to PDF", path: "jpg-to-pdf-converter", category: "Document", icon: <FileImage size={16} /> },
    { id: 33, name: "PDF Merger", path: "pdf-merger", category: "Document", icon: <FilePlus2 size={16} /> },
    { id: 34, name: "Word to JPEG", path: "word-to-jpeg-converter", category: "Document", icon: <FileImage size={16} /> },
    { id: 35, name: "WebP to JPEG", path: "webp-to-jpeg-convert", category: "Document", icon: <FileImage size={16} /> },
    
    // Data Converters
    { id: 36, name: "Binary to Decimal", path: "binary-to-decimal", category: "Data", icon: <Binary size={16} /> },
    { id: 37, name: "Binary to Hex", path: "binary-to-hex", category: "Data", icon: <Binary size={16} /> },
    { id: 38, name: "Binary to Octal", path: "binary-to-octal", category: "Data", icon: <Binary size={16} /> },
    { id: 39, name: "Binary to String", path: "binary-to-string", category: "Data", icon: <Binary size={16} /> },
    { id: 40, name: "Decimal to Binary", path: "decimal-to-binary", category: "Data", icon: <FileDigit size={16} /> },
    { id: 41, name: "Decimal to Hex", path: "decimal-to-hex", category: "Data", icon: <FileDigit size={16} /> },
    { id: 42, name: "Decimal to Octal", path: "decimal-to-octal", category: "Data", icon: <FileDigit size={16} /> },
    { id: 43, name: "Hex to Binary", path: "hex-to-binary", category: "Data", icon: <FileCode size={16} /> },
    { id: 44, name: "Hex to Decimal", path: "hex-to-decimal", category: "Data", icon: <FileCode size={16} /> },
    { id: 45, name: "Hex to Octal", path: "hex-to-octal", category: "Data", icon: <FileCode size={16} /> },
    { id: 46, name: "Data Size", path: "data-size-converter", category: "Data", icon: <FileBarChart2 size={16} /> },
    { id: 48, name: "Octal to Binary", path: "octal-to-binary", category: "Data", icon: <FileDigit size={16} /> },
    { id: 49, name: "Octal to Decimal", path: "octal-to-decimal", category: "Data", icon: <FileDigit size={16} /> },
    { id: 50, name: "Octal to Hex", path: "octal-to-hex", category: "Data", icon: <FileDigit size={16} /> },
    { id: 52, name: "String to Binary", path: "string-to-binary", category: "Data", icon: <FileText size={16} /> }
];
  const toggleCategory = (category) => {
    setExpandedCategories(prev => ({
      ...prev,
      [category]: !prev[category]
    }));
    setActiveCategory(category === activeCategory ? null : category);
  };

  const getFilteredTools = (category) => {
    return tools.filter(tool => tool.category === category);
  };

  const categories = [
    { name: 'All Tools', icon: Layers, color: 'indigo' },
    { name: 'Designing', icon: Paintbrush, color: 'purple', filter: 'Designing' },
    { name: 'Development', icon: Code, color: 'blue', filter: 'Development' },
    { name: 'Marketing', icon: LineChart, color: 'green', filter: 'Marketing' },
    { name: 'Productivity', icon: Mic, color: 'blue', filter: 'Productivity' },
    { name: 'Security', icon: Shield, color: 'red', filter: 'Security' },
    { name: 'Document', icon: FileText, color: 'gray', filter: 'Document' },
    { name: 'Data', icon: Binary, color: 'orange', filter: 'Data' },
  ];

  return (
    <aside className="tool-sidebar sticky top-[64px] h-[calc(100vh-64px)] overflow-y-auto ">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md overflow-hidden">
        <div className="p-4 border-b border-gray-200 dark:border-gray-700">
          <h3 className="font-semibold text-lg text-gray-800 dark:text-white">Categories</h3>
        </div>
        <nav className="divide-y divide-gray-200 dark:divide-gray-700">
          {categories.map((category) => (
            <div key={category.name}>
              <a
                href="#"
                className={`sidebar-link block px-4 py-3 text-gray-700 hover:text-indigo-600 dark:text-gray-300 dark:hover:text-indigo-400 relative hover:bg-indigo-50/10 ${activeCategory === category.name ? 'bg-indigo-50/10 border-r-2 border-indigo-500' : ''}`}
                onClick={(e) => {
                  e.preventDefault();
                  if (category.filter) {
                    toggleCategory(category.name);
                  }
                }}
              >
                <category.icon className={`inline mr-3 h-4 w-4 text-${category.color}-500 dark:text-${category.color}-400`} />
                {category.name}
                {category.filter && (
                  expandedCategories[category.name] ? (
                    <ChevronUp className="inline ml-2 h-4 w-4 float-right" />
                  ) : (
                    <ChevronDown className="inline ml-2 h-4 w-4 float-right" />
                  )
                )}
              </a>
              
              {expandedCategories[category.name] && category.filter && (
                <div className="pl-8 pr-2 py-2 bg-gray-50 dark:bg-gray-700/50 max-h-64 overflow-y-auto scrollbar-thin scrollbar-thumb-rounded scrollbar-thumb-gray-300 dark:scrollbar-thumb-gray-500 hover:scrollbar-thumb-gray-400 dark:hover:scrollbar-thumb-gray-400 scrollbar-track-transparent scrollbar-corner-transparent">
                  {getFilteredTools(category.filter).map(tool => (
                    <a
                      key={tool.id}
                      href={`/tool/${tool.path}`}
                      className="block py-2 text-sm text-gray-600 hover:text-indigo-600 dark:text-gray-300 dark:hover:text-indigo-400 flex items-center"
                    >
                      <span className="mr-2">{tool.icon}</span>
                      {tool.name}
                    </a>
                  ))}
                </div>
              )}
            </div>
          ))}
        </nav>
        <div className="p-4 border-t border-gray-200 dark:border-gray-700">
          <h4 className="font-medium text-gray-700 dark:text-gray-200 mb-2">Popular Tags</h4>
          <div className="flex flex-wrap gap-2">
            <span className="text-xs px-2 py-1 bg-blue-100 dark:bg-blue-900/50 text-blue-800 dark:text-blue-300 rounded-full">
              Images
            </span>
            <span className="text-xs px-2 py-1 bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-300 rounded-full">
              Documents
            </span>
            <span className="text-xs px-2 py-1 bg-purple-100 dark:bg-purple-900/50 text-purple-800 dark:text-purple-300 rounded-full">
              Converters
            </span>
            <span className="text-xs px-2 py-1 bg-red-100 dark:bg-red-900/50 text-red-800 dark:text-red-300 rounded-full">
              Security
            </span>
            <span className="text-xs px-2 py-1 bg-yellow-100 dark:bg-yellow-900/50 text-yellow-800 dark:text-yellow-300 rounded-full">
              Calculators
            </span>
          </div>
        </div>
      </div>

      {/* Add custom scrollbar styles */}
      <style data-jsx="true" data-global="true">{`
        /* Scrollbar styles for modern browsers */
        .scrollbar-thin::-webkit-scrollbar {
          width: 6px;
          height: 6px;
        }

        .scrollbar-thin::-webkit-scrollbar-track {
          background: transparent;
          border-radius: 100px;
        }

        .scrollbar-thin::-webkit-scrollbar-thumb {
          background: #d1d5db;
          border-radius: 100px;
          transition: background 0.2s ease-in-out;
        }

        .scrollbar-thin::-webkit-scrollbar-thumb:hover {
          background: #9ca3af;
        }

        .dark .scrollbar-thin::-webkit-scrollbar-thumb {
          background: #6b7280;
        }

        .dark .scrollbar-thin::-webkit-scrollbar-thumb:hover {
          background: #9ca3af;
        }

        /* For Firefox */
        .scrollbar-thin {
          scrollbar-width: thin;
          scrollbar-color: #d1d5db transparent;
        }

        .dark .scrollbar-thin {
          scrollbar-color: #6b7280 transparent;
        }

        .scrollbar-thin {
          scrollbar-width: none;
          -ms-overflow-style: none;
        }

        .scrollbar-thin::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </aside>
  );
};

export default Sidebar;